import { createContext,useContext, useReducer } from "react";

export const FavoritesContext         =  createContext(null);
export const FavoritesDispatchContext =  createContext(null);


export function FavoriteProvider({children}) {


    const initSetting = { favoritesList : [] }

    const [favoritesList,dispatch] = useReducer(FavoritesReducer,[]);

    return(
        <FavoritesContext value={favoritesList}>
            <FavoritesDispatchContext value={dispatch}>
                {children}
            </FavoritesDispatchContext>
        </FavoritesContext>
    )
}

// reference Functions
export function useFavorites()         { return useContext(FavoritesContext); }
export function useFavoritesDispatch() { return useContext(FavoritesDispatchContext); }

// reducer logic
function FavoritesReducer(favoritesList,oAction) {

    console.log('inside context favorite');

    let sItemExist,
        sItemIndex,
        nFavortitesList,
        oObject = {};
    
    switch (oAction.type) {

        case 'add':
            oObject = {};
            oObject.objID = oAction.objID;
            oObject.isFavorite = true;

            nFavortitesList = [...favoritesList, oObject]

        break; 

        case 'delete':
           nFavortitesList = favoritesList.filter(oItem => oItem.objID !== oAction.objID );

        break; 

        default: //
    }

    return(nFavortitesList);
}